import { FamilyComponentModel } from "./family-component-model";

export class FamilyComponentViewModel extends FamilyComponentModel{
    husbandMarriageAge: string;
    wifeMarriageAge: string;
}